import { createElement, Component, Props as ReactProps } from 'react';
import { DependencyProps } from '../../core/dependency';
import { LocationProps } from '../../core/location';
import { StateProps } from '../../core/state';
import { PaymentOnlyDelivery } from '../components/organisms/PaymentSummary';
import RootFrame from '../components/templates/RootFrame';
import Order from '../../entity/order';
import Store from '../../entity/store';
import {
  Modal,
} from "antd";

type Props = ReactProps<HTMLDivElement> &
  DependencyProps &
  StateProps &
  LocationProps;

type State = {
  isSaving: boolean;
};

class PaymentOnlyDeliveryRoute extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      isSaving: false,
    };

    this.updateOrderField = this.updateOrderField.bind(this);
    this.save = this.save.bind(this);
  }

  public componentWillMount() {
    this.initialize(this.props);
  }

  public componentWillUnmount() {
    this.dispose(this.props);
  }

  public render() {
    const { dependency, location, state } = this.props;
    const {
      order,
      fetches,
      validShipArea,
      validMinPrice,
    } = state.payment;
    const currentStore = state.currentStore;
    if (!currentStore) {
      return null;
    }

    const summaries = <PaymentOnlyDelivery
      order={order || new Order({})}
      updateOrderField={this.updateOrderField}
      onClickSave={this.save}
      regions={currentStore.regionsForType()}
      store={currentStore}
      validShipArea={validShipArea.result}
      validMinPrice={validMinPrice.result}
      isSaving={this.state.isSaving}
    />;

    return <RootFrame
      {...{ dependency, location, state }}
      content={summaries}
      isSpinner={fetches === 1}
    />;
  }

  private async initialize(props: Props) {
    try {
      await props.dependency.payment.initialize();
    } catch (err) {
      window.console.error(err);
    }
  }

  private updateOrderField(partial: Partial<Order>) {
    this.props.dependency.payment.updateEditOrderField(partial);
  }

  private async save() {
    try {
      this.setState({ isSaving: true });
      await this.props.dependency.payment.save();
      const store = this.props.state.currentStore as Store;
      window.location.href = store.confirmUri;
    } catch (e) {
      this.setState({ isSaving: false });
      if (e.graphQLErrors instanceof Array) {
        let message = 'カード情報を確認してください。';
        switch (e.graphQLErrors[0].type) {
          case 'PaymentCardExpireError':
            message = 'カードの有効期限を確認してください。';
            break;
          case 'PaymentCardNumberError':
            message = 'カード番号を確認してください。';
            break;
          case 'PaymentCardCvcError':
            message = 'カードのセキュリティ番号を確認してください。';
            break;
        }
        Modal.error({
          title: 'カード認証失敗',
          content: <div>
            <div>カード認証に失敗しました。</div>
            <div>{message}</div>
          </div>,
        });
        return;
      }
      Modal.error({
        title: '保存に失敗',
        content: <div>
          <div>保存に失敗しました。</div>
          <div>{e.message}</div>
        </div>,
      });
    }
  }

  private dispose(props: Props) {
    try {
      props.dependency.payment.dispose();
    } catch (err) {
      window.console.error(err);
    }
  }
}

export default PaymentOnlyDeliveryRoute;
